(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/competition-handler/client/create-competition-handler.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/competition-handler/client/create-competition-handler.js');
'use strict';

var _svs$competition$data, _svs, _svs$competition$data2, _svs2;
const {
  createCompetitionModel,
  createCompetitionHandlerBase,
  functional: {
    pipe
  }
} = svs.components.marketplaceCompetition.competitionHandler.common;
const {
  createJupiterInstance
} = svs.components.marketplaceCompetition.competitionHandler.client;
const {
  drawHandler
} = svs.components.sport.drawHandler;
const competitionsData = (_svs$competition$data = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.competition) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.competitions) === null || _svs === void 0 ? void 0 : _svs.competitions) !== null && _svs$competition$data !== void 0 ? _svs$competition$data : {};
const activeCompetitionIds = (_svs$competition$data2 = (_svs2 = svs) === null || _svs2 === void 0 || (_svs2 = _svs2.competition) === null || _svs2 === void 0 || (_svs2 = _svs2.data) === null || _svs2 === void 0 || (_svs2 = _svs2.competitions) === null || _svs2 === void 0 ? void 0 : _svs2.activeCompetitionIds) !== null && _svs$competition$data2 !== void 0 ? _svs$competition$data2 : [];
const jupiter = createJupiterInstance();
const createCompetitionHandler = function () {
  let privateInterface = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function () {
    let publicInterface = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    for (const [, competitionData] of Object.entries(competitionsData)) {
      const {
        productId,
        currentDraw: drawNumber
      } = competitionData.model.details;
      const draw = drawHandler().get(productId, drawNumber);
      const competition = createCompetitionModel(competitionData, draw);
      privateInterface.competitionCache.setModel(competition);
    }
    privateInterface.setCmsCompetitionIds(activeCompetitionIds);


    return publicInterface;
  };
};

const privateInterface = {
  jupiter
};
const fns = [createCompetitionHandlerBase, createCompetitionHandler].map(fn => fn(privateInterface));
const competitionHandlerCreator = pipe(...fns);
setGlobal('svs.components.marketplaceCompetition.competitionHandler.client.createCompetitionHandler', competitionHandlerCreator);

 })(window);